import MapView from "../map/MapView";
import SideBySideMapView from "../map/SideBySideMapView";
import {AppActions, useAppContext} from "../../context/AppContext";
import {v4} from "uuid";
import {useState} from "react";

const getTiles = () => {
    return [
        {tile: 'Google Street', url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'Google Hybrid', url: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Satellite', url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Terrain', url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'OpenStreetMap', url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'None', url: '', options: {maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080', isBlank: true},
    ]
}

export default function MapTab() {
    const {selectedHistoryId, getSelectedHistory, dispatchProject, getProjectLayers, getRiverBoundingCoords, getMapData, appContext, filter, getSelectedRS} = useAppContext()
    const type = appContext?.selectedMapType || 'base'
    const [sharedTile, setSharedTile] = useState(getTiles()[0])
    
    // Check if compare data exists
    const hasCompareData = !!getMapData('compare')

    const getProjectInfo = (mapType) => {
        const selection = getSelectedHistory()?.selection[mapType]
        return {
            title: `${selection?.project?.information?.title} (${selection?.project?.information?.folderName})`,
            plan: `${selection?.plan?.type} (.${selection?.plan?.plan?.ext})`,
            river: selection?.river?.river ? `${selection?.river?.river} - ${selection?.river?.reach}` : '',
        }
    }

    const handleTypeChange = (newType) => {
        if ((newType === 'compare' || newType === 'sidebyside') && !hasCompareData) return
        dispatchProject({
            type: AppActions.SET_MAP_TYPE,
            data: { mapType: newType }
        })
    }

    const createProjectLayerChangeHandler = (mapType) => (shapes) => {
        const _project = appContext?.projects?.find(x => x.id === getSelectedHistory()?.selection[mapType]?.project?.id)
        if (_project) {
            _project.shapes = [...shapes]
            dispatchProject({
                type: AppActions.SET_PROJECT,
                data: {
                    project: {
                        ..._project
                    },
                    map: {
                        type: mapType,
                        [mapType]: {
                            update: v4()
                        }
                    }
                }
            })
        }
    }

    // Side-by-side mode
    if (type === 'sidebyside' && hasCompareData) {
        const baseProps = {
            type: 'base',
            currentMapType: 'sidebyside',
            projection: getSelectedHistory()?.selection['base']?.project?.projection?.text,
            filter,
            projectInfo: getProjectInfo('base'),
            updateKey: selectedHistoryId,
            mapData: getMapData('base'),
            projectLayers: getProjectLayers('base'),
            riverBoundingCoords: getRiverBoundingCoords('base'),
            selectedRS: getSelectedRS(),
            onTypeChange: handleTypeChange,
            hasCompareData,
            onProjectLayerChange: createProjectLayerChangeHandler('base'),
            isSideBySide: true
        };

        const compareProps = {
            type: 'compare',
            currentMapType: 'sidebyside',
            controlPosition: 'topright',
            projection: getSelectedHistory()?.selection['compare']?.project?.projection?.text,
            filter,
            projectInfo: getProjectInfo('compare'),
            updateKey: selectedHistoryId,
            mapData: getMapData('compare'),
            projectLayers: getProjectLayers('compare'),
            riverBoundingCoords: getRiverBoundingCoords('compare'),
            selectedRS: getSelectedRS(),
            hasCompareData,
            onProjectLayerChange: createProjectLayerChangeHandler('compare'),
            isSideBySide: true
        };

        return (
            <SideBySideMapView
                key="sidebyside-view"
                baseProps={baseProps}
                compareProps={compareProps}
                onTypeChange={handleTypeChange}
                hasCompareData={hasCompareData}
                sharedTile={sharedTile}
                onTileChange={setSharedTile}
                tiles={getTiles()}
                mapData={getMapData('base')}
                dispatchProject={dispatchProject}
            />
        );
    }

    // Normal single map mode
    return (
        <>
            <MapView
                key={`single-map-${type}`}
                type={type}
                projection={getSelectedHistory()?.selection[type]?.project?.projection?.text}
                filter={filter}
                projectInfo={getProjectInfo(type)}
                updateKey={selectedHistoryId}
                mapData={getMapData(type)}
                projectLayers={getProjectLayers(type)}
                riverBoundingCoords={getRiverBoundingCoords(type)}
                selectedRS={getSelectedRS()}
                onTypeChange={handleTypeChange}
                hasCompareData={hasCompareData}
                onProjectLayerChange={createProjectLayerChangeHandler(type)}
            />
        </>
    )
}